@if (showCommandBar) {
  <div class="pcp-commandbar" [class.pcp-commandbar-fixed]="_isPositionFixed" [class.d-flex]="!_isPositionFixed">
    <div class="d-flex flex-row flex-fill align-items-center">
      <div #leftSection class="command-bar-image d-flex flex-fill justify-content-start">
        <ng-content select="[button-left]" />
      </div>
      <div #rightSection class="d-flex flex-fill justify-content-end">
        <ng-content select="[button-right]" />
      </div>
    </div>
  </div>
}